// @flow

import * as React from 'react';
import { isIOS } from '../utils/is-ios';

const renderedStyles = new Set();

const useGlobalStyle = style => {
  React.useEffect(() => {
    if (renderedStyles.has(style) === false) {
      renderedStyles.add(style);
      const styleElement = document.createElement('style');
      styleElement.appendChild(document.createTextNode(style));
      document.head?.appendChild(styleElement);
    }
  }, [style]);
};

const forceToolbarOn = () => {
  window.document.body.classList.add('realadvisor-ios-force-toolbars');
  window.document.documentElement.classList.add(
    'realadvisor-ios-force-toolbars',
  );
};

const forceToolbarOff = () => {
  window.document.body.classList.remove('realadvisor-ios-force-toolbars');
  window.document.documentElement.classList.remove(
    'realadvisor-ios-force-toolbars',
  );
};

let applyRequests = 0;
let dontApplyRequests = 0;

// This is useful when we have a button at the bottom of the screen
// that conflicts with iOS Safari behaviour to show toolbar when user click at the bottom.
// We workaround this by always showing toolbars.
// https://stackoverflow.com/a/34033413
//
// true: apply the hack
// false: negate applyHack=true set by other instances
// null: do nothing
export const useForceIOSToolbar = (applyHack: ?boolean) => {
  if (isIOS === true) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useGlobalStyle(`
      .realadvisor-ios-force-toolbars {
        height: 100%;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
      }
    `);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
      if (applyHack === true) {
        applyRequests += 1;
        if (applyRequests === 1 && dontApplyRequests === 0) {
          forceToolbarOn();
        }
        return () => {
          applyRequests -= 1;
          if (applyRequests === 0 && dontApplyRequests === 0) {
            forceToolbarOff();
          }
        };
      }

      if (applyHack === false) {
        dontApplyRequests += 1;
        if (dontApplyRequests === 1 && applyRequests !== 0) {
          forceToolbarOff();
        }
        return () => {
          dontApplyRequests -= 1;
          if (dontApplyRequests === 0 && applyRequests !== 0) {
            forceToolbarOn();
          }
        };
      }
    }, [applyHack]);
  }
};

let disableScrollRequests = 0;
let lastScrollTop = 0;

const disableScrollOn = () => {
  lastScrollTop = window.pageYOffset;
  window.document.body.style.top = `-${lastScrollTop}px`;
  window.document.body.classList.add('realadvisor-ios-disable-scroll');
};

const disableScrollOff = () => {
  window.document.body.classList.remove('realadvisor-ios-disable-scroll');
  window.scrollTo(0, lastScrollTop);
};

export const useDisableIOSBodyScroll = (applyHack: boolean) => {
  if (isIOS === true) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useGlobalStyle(`
      .realadvisor-ios-disable-scroll {
        position: fixed;
        width: 100%;
      }
    `);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
      if (applyHack === true) {
        disableScrollRequests += 1;
        if (disableScrollRequests === 1) {
          disableScrollOn();
        }
        return () => {
          disableScrollRequests -= 1;
          if (disableScrollRequests === 0) {
            disableScrollOff();
          }
        };
      }
    }, [applyHack]);
  }
};
